import {injectable} from "tsyringe";
import {BulkCommand} from "../commands/bulk.command";
import {ICommand} from "../commands/i-command.interface";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {TransformerHelper} from "../helpers/transformer.helper";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: BulkCommand,
    target: `dto`
})
export class BulkCommandToDtoTransformer extends AbstractCommandToDtoTransformer<ICommand[]> {

    protected async toDTO(payloads: ICommand[]): Promise<DataTransferObject[]> {
        return Promise.all(payloads.map(payload => TransformerHelper.toDTO(payload)));
    }
}